import React, {useState, useEffect} from "react";
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import IntroLoader from './components/IntroLoader';
import './index.scss';

function App() {
    const [mode, setMode] = useState<string>('dark');
    const [showIntro, setShowIntro] = useState<boolean>(true);

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
    <>
        {showIntro && <IntroLoader onComplete={() => setShowIntro(false)} />}
        <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
            <Main/>
            <Expertise/>
            <Timeline/>
            <Project/>
            <Contact/>
            <Footer />
        </div>
    </>
    );
}

export default App;